export enum BusinessTypes {
  STARTER = 1,
  SOLE_PROPRIETOR = 2,
  PARTNERSHIP = 3,
  CORPORATION = 4,
}

export enum BusinessTypesText {
  STARTER = "Starter Business",
  SOLE_PROPRIETOR = "Sole Proprietor",
  PARTNERSHIP = "Partnership",
  CORPORATION = "Corporation",
}

export enum BusinessTypesCode {
  STARTER = "STARTER",
  SOLE_PROPRIETOR = "SOLE_PROPRIETOR",
  PARTNERSHIP = "PARTNERSHIP",
  CORPORATION = "CORPORATION",
}
